import { H1 } from "@/components/Heading";
import { AppLink } from "@/routing/AppLink";
import { Button, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { useEffectOnce } from "usehooks-ts";
import { telemetry } from "@/telemetry";

export const PageNotFoundPanel = () => {
  useEffectOnce(() =>
    telemetry.trackEvent("page_not_found", {
      path: window.location.pathname,
      referrer_host: telemetry.getHost(document.referrer),
    }),
  );

  return (
    <Stack
      textAlign="center"
      spacing="8"
    >
      <H1> 404 - Page Not Found</H1>
      <Text> Sorry, the page you are looking for does not exist.</Text>
      <AppLink to="/">
        <Button>Go to Home Page</Button>
      </AppLink>
    </Stack>
  );
};
